import { NavigationType, SubMenuType } from '../types/navigation.type';

export const navigation: NavigationType[] = [
  {
    name: 'Dashboard',
    label: 'Dashboard',
    link: '/dashboard',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/home-hashtag.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/home-hashtag.svg',
    },
  },
  {
    name: 'Shipping API',
    label: 'Shipping API',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/truck-fast.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/truck-fast.svg',
    },
    children: [
      {
        name: 'Shipping Order Data',
        label: 'Order Data',
        link: '/order-data',
      },
      {
        name: 'Shipping Issue',
        label: 'Issue',
        link: '/ticketing',
      },
      {
        name: 'Shipping Rates & Track',
        label: 'Rates & Track',
        link: '/rates-track',
      },
      {
        name: 'Shipping Simulator',
        label: 'Simulator',
        link: '/misc/simulator',
      },
      {
        name: 'Custom Label',
        label: 'Custom Label',
        link: '/misc/custom-label',
      },
    ],
  },
  {
    name: 'Payment API',
    label: 'Payment API',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/money-send.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/money-send.svg',
    },
    children: [
      {
        name: 'Payment Page',
        label: 'Payment Page',
        link: '/account/payment',
      },
      {
        name: 'QRISLY',
        label: 'QRISLY',
        link: '/qrisly',
      },
      {
        name: 'Generate QRIS',
        label: 'Generate QRIS',
        link: '/generate-qris',
      },
      {
        name: 'Payment Invoices',
        label: 'Invoices',
        link: '/misc/invoices',
      },
    ],
  },
  {
    name: 'Finance',
    label: 'Finance',
    link: '/finance',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/empty-wallet.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/empty-wallet.svg',
    },
  },
  {
    name: 'Subscriptions',
    label: 'Subscriptions',
    link: '/subscriptions',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/bill.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/bill.svg',
    },
  },
  {
    name: 'Developer',
    label: 'Developer',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/code-circle.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/code-circle.svg',
    },
    children: [
      {
        name: 'Webhook',
        label: 'Webhook',
        link: '/webhook',
      },
      {
        name: 'Developer Settings',
        label: 'API Key',
        link: '/settings',
      },
      {
        name: 'Document',
        label: 'Document',
        link: '/account/document',
      },
      {
        name: 'API Docs & Plugin',
        label: 'API Docs & Plugin',
        link: '/integration',
      },
    ],
  },
  {
    name: 'Account',
    label: 'Settings',
    icon: {
      active:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/setting-2.svg',
      default:
        'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/setting-2.svg',
    },
    children: [
      {
        name: 'Profile',
        label: 'Profile',
        link: '/account/profile',
      },
      {
        name: 'Bank Account',
        label: 'Bank Account',
        link: '/account/bank-account',
      },
      {
        name: 'PIN',
        label: 'PIN',
        link: '/account/pin',
      },
      {
        name: 'Expedition',
        label: 'Expedition',
        link: '/account/expedition',
      },
      {
        name: 'Teams',
        label: 'Teams',
        link: '/account/teams',
      },
    ],
  },
];
